module.exports = __webpack_public_path__ + "img/9788963860121.5fcf76dd.jpg";